module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_weekendsale_small_de-2f97fcbd70da5402209993fe746be01f.jpg";